import { useState } from 'react';
import { paymentLinkStorage } from '../services/paymentApi';
import { useGeneratePaymentLink } from './useGeneratePaymentLink';

/**
 * The payment link for a call's invoice, and making one
 * (POST /invoices/:id/payment-link, through Square or RoadSync, whichever
 * the company uses). GET /calls/:id/payment says whether a link was made
 * but never sends it back, so the phone that made it keeps it for a day, as
 * the old payment screen does; on another phone, or after that, a new one
 * is made.
 */
export const usePaymentLink = (
  callId: string | undefined,
  companyId: string | undefined
) => {
  const generate = useGeneratePaymentLink(callId, companyId);
  const [link, setLink] = useState<string | null>(() =>
    callId ? paymentLinkStorage.getPaymentLink(callId) : null
  );

  const make = async (invoiceId: string): Promise<string> => {
    const { paymentLink } = await generate.mutateAsync(invoiceId);
    if (!paymentLink) throw new Error('The payment link was not made.');
    if (callId) paymentLinkStorage.savePaymentLink(callId, paymentLink);
    setLink(paymentLink);
    return paymentLink;
  };

  return { link, make, making: generate.isPending };
};
